import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowSquareOutIcon } from '@yonderland/andes-icons';
import { Box, Link, Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { generateTestId } from '../../../util/TestUtil';
import WarrantyBadge10 from './assets/WarrantyBadge10';
import WarrantyBadge20 from './assets/WarrantyBadge20';
import WarrantyBadge25 from './assets/WarrantyBadge25';
import WarrantyBadge3 from './assets/WarrantyBadge3';
import WarrantyBadge30 from './assets/WarrantyBadge30';
import WarrantyBadge5 from './assets/WarrantyBadge5';
import WarrantyBadge7 from './assets/WarrantyBadge7';
const WARRANTY_LABEL_TEST_ID = 'warranty-label';
const WARRANTY_BADGES = {
    3: _jsx(WarrantyBadge3, {}),
    5: _jsx(WarrantyBadge5, {}),
    7: _jsx(WarrantyBadge7, {}),
    10: _jsx(WarrantyBadge10, {}),
    20: _jsx(WarrantyBadge20, {}),
    25: _jsx(WarrantyBadge25, {}),
    30: _jsx(WarrantyBadge30, {}),
};
/**
 * Displays a warranty section with a GARAN badge SVG matching the warranty duration and a 'read more' link.
 * Add a new entry to WARRANTY_BADGES when a new warranty period SVG is provided by the design team.
 * Used inside PDP tab containers when the AEM `showWarrantyInTab` toggle is enabled.
 */
export const WarrantyLabel = ({ warrantyYears, onReadMoreClick }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const badge = WARRANTY_BADGES[warrantyYears];
    if (!badge) {
        return null;
    }
    return (_jsxs(Stack, { direction: "col", gap: "2", testId: WARRANTY_LABEL_TEST_ID, children: [_jsx(TextAlpha, { variant: "subheadingM", color: "emphasised", as: "h2", testId: generateTestId({ testId: WARRANTY_LABEL_TEST_ID, suffix: 'title' }), children: t('pdp.warranty.title') }), _jsx(Box, { backgroundColor: "quiet-3", borderRadius: "md", padding: "4", testId: generateTestId({ testId: WARRANTY_LABEL_TEST_ID, suffix: 'badge' }), children: _jsxs(Stack, { direction: "col", gap: "3", wrap: "nowrap", align: "start", children: [badge, _jsx(Link, { theme: "neutral", variant: "secondary", onClick: onReadMoreClick, iconRight: { source: ArrowSquareOutIcon }, testId: generateTestId({ testId: WARRANTY_LABEL_TEST_ID, suffix: 'link' }), children: t('pdp.warranty.readmore') })] }) })] }));
};
